import Request from '@/requests/Request'
const resource_indicadores = "/indicadores";
const resource_lancamentos = "lancamentos";
const resource = "/indicadores/{indicadorId}/lancamentos"

export default {
  findByIndicadorId(indicadorId) {
    return Request.get(`${resource_indicadores}/${indicadorId}/${resource_lancamentos}`)
  },

  post(indicadorId, lancamento) {
    const url = resource.replace(new RegExp("{indicadorId}", "g"), indicadorId)
    return Request.post(`${url}`, lancamento)
  },
  
  put(payload) {
    const url = resource.replace(new RegExp("{indicadorId}", "g"), payload.indicadorId).concat(`/${payload.lancamentoId}`)
    payload.lancamento["lancadoPorId"] = payload.responsavelLancamentoID

    return Request.put(`${url}`, payload.lancamento)

  },
  

  putMonitoramento(payload) {
    const url = resource.replace(new RegExp("{indicadorId}", "g"), payload.indicadorId).concat(`/${payload.lancamentoId}/monitoramento`)

    const form = new FormData();
    form.append('progresso', payload.progresso);
    form.append('responsavelId', payload.responsavelId);
    form.append('data', payload.data);
    form.append("lancamentoId", payload.lancamentoId)

    form.append("status", payload.status)
    form.append("observacoes", payload.observacoes)

    form.append("lancamentoProgressos", payload.lancamentoProgressos)


    return Request.put(`${url}`, form)

  },

  putMonitoramento2(payload) {
    const url = resource.replace(new RegExp("{indicadorId}", "g"), payload.indicadorId).concat(`/${payload.lancamentoId}/monitoramento2`)

    payload.lancamentoProgressos.forEach(item => {
      item.progresso = item.progresso.toString().replace(',', '.')
    });

    payload.progresso = payload.progresso.toString().replace(',', '.')

    let monitoramentoDTO  = {
      "progresso": payload.progresso,
      "responsavelId": payload.responsavelId,
      "status": payload.status,
      "data": payload.data,
      "observacoes": payload.observacoes,
      "lancamentoProgressos": payload.lancamentoProgressos
    }

    console.log(monitoramentoDTO)


    return Request.put(`${url}`, monitoramentoDTO)

  },

  
  putEnviaMonitoramento(payload) {
    console.log('A')
    //return Request.put(`${resource_indicadores}/${payload.indicadorId}/${resource_lancamentos}/${payload.lancamentoId}/aguardando-monitoramento`)
    const url = resource.replace(new RegExp("{indicadorId}", "g"), payload.indicadorId).concat(`/${payload.lancamentoId}/envia-monitoramento`)
    console.log('B: ', url)
    return Request.put(`${url}`)
  },

  delete(payload) {
    const url = resource.replace(new RegExp("{indicadorId}", "g"), payload.indicadorId).concat(`/${payload.lancamentoId}`)
    return Request.delete(`${url}`)
  },


}